<template>
  <div>
    <div class="title">{{ $t('doc.status_code_title') }}</div>
    <div class="table">
      <el-table :data="tableData" :header-cell-style="{
        backgroundColor: '#0077FF',
        color: '#FFF',
        fontWeight: '500'
      }">
        <el-table-column prop="code" :label="$t('doc.col_code')" width="400" >
        </el-table-column>
        <el-table-column prop="tips" :label="$t('doc.col_tips')" >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "OpenWebCode",

  data() {
    return {};
  },
  computed: {
    // tableData 转 computed：提示文案随语言热切换
    tableData() {
      return [
        { code: "10601", tips: this.$t("doc.code_10601") },
        { code: "10606", tips: this.$t("doc.code_10606") },
        { code: "10607", tips: this.$t("doc.code_10607") },
        { code: "10609", tips: this.$t("doc.code_10609") },
        { code: "10610", tips: this.$t("doc.code_10610") },
        { code: "10614", tips: this.$t("doc.code_10614") },
        { code: "401", tips: this.$t("doc.code_401") },
        { code: "400", tips: this.$t("doc.code_400") },
      ];
    },
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.title {
  padding: 10px 0;
  font-size: 24px;
  font-weight: 500;
}
.table{
  width: 75%;
}
</style>